import React from "react";
import "./styles/TrustedBy.css";

function TrustedBy() {
  const brands = [
    {
      name: "Apple",
      logo: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
        </svg>
      ),
    },
    {
      name: "Samsung",
      logo: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M19.8166 12.1228C19.8166 12.8481 19.4428 13.4161 18.8334 13.4161C18.2239 13.4161 17.8502 12.8481 17.8502 12.1228C17.8502 11.3975 18.2239 10.8228 18.8334 10.8228C19.4428 10.8228 19.8166 11.3975 19.8166 12.1228ZM13.3999 12.1228C13.3999 12.8481 13.0262 13.4161 12.4167 13.4161C11.8073 13.4161 11.4335 12.8481 11.4335 12.1228C11.4335 11.3975 11.8073 10.8228 12.4167 10.8228C13.0262 10.8228 13.3999 11.3975 13.3999 12.1228ZM6.98324 12.1228C6.98324 12.8481 6.60951 13.4161 6.00006 13.4161C5.39062 13.4161 5.01689 12.8481 5.01689 12.1228C5.01689 11.3975 5.39062 10.8228 6.00006 10.8228C6.60951 10.8228 6.98324 11.3975 6.98324 12.1228ZM22.3166 12.1228C22.3166 16.8241 18.5012 20.6228 13.7833 20.6228H11.0501C6.33227 20.6228 2.51689 16.8241 2.51689 12.1228C2.51689 7.42151 6.33227 3.62283 11.0501 3.62283H13.7833C18.5012 3.62283 22.3166 7.42151 22.3166 12.1228Z" />
        </svg>
      ),
    },
    {
      name: "Google",
      logo: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
        </svg>
      ),
    },
    {
      name: "Huawei",
      logo: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M7.47024 18.4854C6.30682 17.9801 5.28153 17.2346 4.45972 16.2897C3.63791 15.3448 3.03991 14.2232 2.70873 13.0103C2.37755 11.7973 2.32166 10.5239 2.54512 9.28702C2.76858 8.05018 3.26673 6.88366 4.00424 5.87251C4.74175 4.86137 5.70018 4.03177 6.81191 3.44356C7.92363 2.85535 9.15871 2.52344 10.4208 2.47192C11.683 2.42041 12.9402 2.65047 14.0983 3.14761C15.2564 3.64475 16.2871 4.39647 17.1152 5.33849L12.2927 10.1609L7.47024 18.4854Z M16.5298 18.4854C15.3663 18.9907 14.0992 19.2358 12.8237 19.2003C11.5481 19.1648 10.2974 18.8495 9.16561 18.2799C8.03387 17.7103 7.04816 16.9012 6.28813 15.9115C5.52811 14.9218 5.01239 13.7768 4.76751 12.5578C4.52263 11.3387 4.55424 10.0789 4.86012 8.87391C5.166 7.66889 5.73789 6.54936 6.53596 5.59324C7.33403 4.63712 8.33752 3.86854 9.47343 3.34225C10.6093 2.81596 11.8473 2.54492 13.0998 2.54492L12.2927 10.1609L16.5298 18.4854Z M19.9998 12.2729C19.9998 13.5454 19.7033 14.7993 19.1311 15.9361C18.559 17.0729 17.726 18.0611 16.6901 18.8276L12.2927 10.1609L19.9998 2.45374V12.2729Z" />
        </svg>
      ),
    },
    {
      name: "Sony",
      logo: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.4998 2.27283H6.74983C6.74983 2.27283 2.99983 2.52283 2.99983 6.27283C2.99983 9.77283 2.99983 14.5228 2.99983 17.7728C2.99983 20.5228 5.24983 21.7728 7.49983 21.7728H16.4998C19.2498 21.7728 20.9998 19.7728 20.9998 17.7728V6.27283C20.9998 3.77283 18.7498 2.27283 16.4998 2.27283H12.4998ZM12.4998 18.5228C8.24983 18.5228 4.74983 15.0228 4.74983 10.7728C4.74983 6.52283 8.24983 3.02283 12.4998 3.02283C16.7498 3.02283 20.2498 6.52283 20.2498 10.7728C20.2498 15.0228 16.7498 18.5228 12.4998 18.5228Z" />
        </svg>
      ),
    },
  ];

  return (
    <section className="trusted-by">
      <div className="container">
        <p className="section-note">
          More than 100,000+ people around the globe rely on RoamBis
        </p>
        <div className="trust-logos">
          {brands.map((brand, index) => (
            <div key={index} className="trust-logo" title={brand.name}>
              {brand.logo}
            </div>
          ))}
        </div>
        <p className="trust-note">Compatible with all eSIM enabled devices</p>
      </div>
    </section>
  );
}

export default TrustedBy;
